import React from 'react';
import { FaUser, FaMapMarkerAlt, FaPhoneAlt, FaTruck } from 'react-icons/fa';
import * as S from '../GraciasPage.styles';

/**
 * Lista de información requerida para la entrega
 */
const PaymentInfo = ({ t }) => {
  const infoItems = [
    { icon: FaUser, text: t('gracias.success.info1') },
    { icon: FaMapMarkerAlt, text: t('gracias.success.info2') },
    { icon: FaPhoneAlt, text: t('gracias.success.info3') },
    { icon: FaTruck, text: t('gracias.success.info4') },
  ];

  return (
    <S.InfoList>
      {infoItems.map((item, index) => {
        const IconComponent = item.icon;
        return (
          <S.InfoItem key={index}>
            <IconComponent />
            {item.text}
          </S.InfoItem>
        );
      })}
    </S.InfoList>
  );
};

export default PaymentInfo;

